import * as types from 'actions/types';
import { createReducer, successType } from 'shared/lib/lib/callAPI';

const dataReducer = (state = null, action) => {
  switch (action.type) {
    case successType(types.GET_USER_SKILLS):
      return [...action.response];
    case types.SET_USER_SKILLS:
      return [...action.data];
    case types.LOGOUT:
      return null;
    default:
      return state;
  }
};

export default createReducer(types.GET_USER_SKILLS, dataReducer);
